import log from './utils/logging';

/**
 * Load videos in infinite scroll articles.
 *
 * @param {ParentNode} content
 * @returns {void}
 */
export function initializeYPPlayers(content) {
  const YOUPLAY_REGEX = /^https:\/\/delivery.youplay.se\/load.js\?id=\d{11,}$/;

  Array.from(content?.querySelectorAll('.yp') || [])
    .filter((el) => !el?.hasAttribute('id') && YOUPLAY_REGEX.test(el?.src || ''))
    .forEach(({ src }) => {
      // FIXME: use our own getScript instead
      $.getScript(src)
        .done(() => log.info('[YouPlay] Video loaded: ', src))
        .fail(() => log.info('[YouPlay] Error loading video: ', src));
    });
}
